import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrManager } from 'ng6-toastr-notifications';
import { MasterService } from '../../../services/master.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent {
  valForm: FormGroup;
  btn3: any;
  constructor(public fb: FormBuilder, public toastr: ToastrManager,
    public service: MasterService, private router: Router) {
    this.valForm = this.fb.group({
      'username': [null,],
      'password': [null,]
    });
    sessionStorage.clear();
  }
  get_login() {
    this.btn3 = true;
    this.service.get_login(this.valForm.value.username, this.valForm.value.password).subscribe(get_data => {
      console.log(get_data)
      if (get_data['data'][0]['user_name']) {
        this.toastr.successToastr('Login Success', 'Success!');
        // this.router.navigate(['/office-expense'])
        this.router.navigate(['/candidate-details'])
        sessionStorage.setItem("data", JSON.stringify(get_data['data']));
        this.btn3 = false;
      }
      else {
        this.btn3 = false;
        this.toastr.errorToastr('Failed', get_data['data'][0]['INVALID_USER_NAME_AND_PASSWORD']);
      }
    },error=>{
      this.btn3 = false;
      this.toastr.errorToastr('Connection Error');
    })
  }
}